import { useCountriesList } from "@inno-tools/react-hooks";
import { PhoneInput, PhoneInputSizes } from "@inno-ui/phone-input";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { useFieldContext } from "../../hooks/use-form";

type PhoneInputFieldProps = {
  label: string;
  width?: string;
};

export function PhoneInputField({ label, width }: PhoneInputFieldProps) {
  const { t, i18n } = useTranslation();
  const field = useFieldContext<string>();
  const rawCountries = useCountriesList();
  const { pathname } = useLocation();
  const path = pathname.split("/")[1];
  const isEmbed = path === "embed";

  const countries = useMemo(() => {
    const regionNames = new Intl.DisplayNames([i18n.language], { type: "region" });
    return rawCountries.map(country => ({
      ...country,
      name: regionNames.of(country.code.toUpperCase()) ?? country.name,
    }));
  }, [rawCountries, i18n.language]);

  return (
    <PhoneInput
      label={label}
      name="phone"
      size={PhoneInputSizes.M}
      placeholder="0000000000"
      width={width}
      errorText={t(field.state.meta.errors[0]?.message)}
      value={field.state.value}
      onChange={data => field.handleChange(data.phone)}
      countries={countries}
      config={isEmbed ? { defaultCountry: "us" } : undefined}
    />
  );
}
